const constants = {
  COMPANY_LOADING_START: 'COMPANY_LOADING_START',
  COMPANY_LOADING_END: 'COMPANY_LOADING_END',
  COMPANY_FETCH: 'COMPANY_FETCH',
  COMPANY_CLEAR: 'COMPANY_CLEAR',
  COMPANY_SET_IS_EDIT: 'COMPANY_SET_IS_EDIT',
  COMPANY_CHANGE_FORM: 'COMPANY_CHANGE_FORM',
  COMPANY_SET_ERROR: 'COMPANY_SET_ERROR',
  COMPANY_SAVE_SUCCESS: 'COMPANY_SAVE_SUCCESS',
};

export default constants;
